<template>
  <div class="">
    <a-spin v-if="loading" tip="Loading...">
      <a-alert
        message="Mohon Tunggu."
        description="Loading data dashboard..."
        type="info"
      />
    </a-spin>
    <div v-else>
      <div class="cui__utils__heading"><strong>LAYMEN JOURNEY</strong></div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ totalPatient }}
              </div>
              <div class="text-uppercase">
                Total Patients
                <!-- <span class="text-success">
                  {{
                    countPercentage(
                      verifiedPatientsCount,
                      registeredUserCompletedProfileCount,
                    )
                  }}
                  <small> % </small></span
                > -->
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ registeredUsersCount }}
              </div>
              <div class="text-uppercase">
                Registered Users
                <span class="text-success"> 100 <small> % </small></span>
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ registeredUserEmailVerifiedCount }}
              </div>
              <div class="text-uppercase">
                Verified Email
                <span class="text-secondary">
                  {{
                    countPercentage(
                      registeredUserEmailVerifiedCount,
                      registeredUsersCount,
                    )
                  }}
                  <small> % </small></span
                >
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ registeredUserCompletedProfileCount }}
              </div>
              <div class="text-uppercase">
                Completed Profile
                <span class="text-secondary">
                  {{
                    countPercentage(
                      registeredUserCompletedProfileCount,
                      registeredUserEmailVerifiedCount,
                    )
                  }}
                  <small> % </small></span
                >
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ verifiedPatientsCount }}
              </div>
              <div class="text-uppercase">
                Verified Patients
                <span class="text-success">
                  {{
                    countPercentage(verifiedPatientsCount, registeredUsersCount)
                  }}
                  <small> % </small></span
                >
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ migratedPatientCount }}
              </div>
              <div class="text-uppercase">
                Migration Patients
                <span class="text-success">
                  {{
                    countPercentage(migratedPatientCount, registeredUsersCount)
                  }}
                  <small> % </small></span
                >
              </div>
              <div :class="$style.chartContainer"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cui__utils__heading"><strong>PATIENT'S JOURNEY</strong></div>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ verifiedPatientsCount }}
              </div>
              <div class="text-uppercase">
                Verified Patients
                <span class="text-success">
                  {{ registeredUsersCount ? 100 : 0 }} <small> % </small></span
                >
              </div>
              <div class="small text-muted">
                Patients approved by verificator
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ extendingPatientsCount }}
              </div>
              <div class="text-uppercase">
                Extended Patients
                <span class="text-warning">
                  {{
                    countPercentage(extendingPatientsCount, activePatientsCount)
                  }}
                  <small> % </small></span
                >
              </div>
              <div class="small text-muted">
                Patients that clicked extends button
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ activePatientsCount }}
              </div>
              <div class="text-uppercase">
                Scanned Patients (Active Patients)
                <span class="text-warning">
                  {{
                    countPercentage(activePatientsCount, verifiedPatientsCount)
                  }}
                  <small> % </small></span
                >
              </div>
              <div class="small text-muted">
                Patients approved by verificator, and scanned by pharmacy
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ totalTerminated }}
              </div>
              <div class="text-uppercase">
                Terminated Patients
                <!-- <span class="text-success">
                  {{
                    countPercentage(
                      verifiedPatientsCount,
                      registeredUserCompletedProfileCount,
                    )
                  }}
                  <small> % </small></span
                > -->
              </div>
              <div class="small text-muted">Patients end the programs</div>
            </div>
          </div>
          <!-- <div class="card">
            <div class="card-body position-relative overflow-hidden">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{ pendingExtendingPatient }}
              </div>
              <div class="text-uppercase">
                Pending Extending Patients
                <span class="text-success">
                  {{
                    countPercentage(
                      pendingExtendingPatient,
                      verifiedPatientsCount,
                    )
                  }}
                  <small> % </small></span
                >
              </div>
              <div class="small text-muted">
                Extending patients that not upload prescription or verified
              </div>
            </div>
          </div> -->
        </div>
        <div class="col-xl-4">
          <div class="col-xl-12">
            <div class="card">
              <div class="pt-3 pb-1 px-3 position-relative overflow-hidden">
                <h5 class=""><strong>Patients by Gender</strong></h5>
                <div class="d-flex justify-content-between mb-4">
                  <pie-chart-legends
                    :maleCount="maleCount"
                    :femaleCount="femaleCount"
                    class="d-flex align-items-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="d-flex">
      <download-excel
        :data="json_data"
        :fields="json_fields"
        worksheet="My Worksheet"
        name="All Patients.xls"
      >
      <a-button type="button" class="btn btn-outline-info mb-4 mx-2"> <a-icon type="download" /> Download All Users Data </a-button>
      </download-excel>
      <download-excel
        :data="active_data"
        :fields="json_fields"
        worksheet="My Worksheet"
        name="Active Patients.xls"
      >
      <a-button type="button" class="btn btn-outline-success mb-4 mx-2"> <a-icon type="download" /> Download Active Patients Data </a-button>
      </download-excel>
      <download-excel
        :data="terminated_data"
        :fields="json_fields"
        worksheet="My Worksheet"
        name="Terminated Patients.xls"
      >
      <a-button type="button" class="btn btn-outline-warning mb-4 mx-2"> <a-icon type="download" /> Download Terminated Patients Data </a-button>
      </download-excel>
    </div> -->
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="800px"
        :html-to-pdf-options="html2pdfoption"
        ref="html2Pdf"
      >
        <section slot="pdf-content">
          <div class="col-xl-6 col-lg-12">
            <h5 class="mb-4">
              <strong>Total Pasien</strong>
            </h5>
            <div class="mb-5">
              <vue-chartist
                class="height-300"
                type="Bar"
                :data="monthlyPatientData"
                :options="monthlyPatientOptions"
              />
            </div>
          </div>
          <!-- PDF Content Here -->
        </section>
      </vue-html2pdf>
      <div class="row mb-3">
        <div class="col-12">
          <h1>Total Pharmacy Unscanned</h1>
          <a-date-picker
            mode="month"
            v-model="value"
            @change="onDateValueChange"
            @panelChange="handlePanelChange2"
            @openChange="handleOpenChange"
            format="YYYY-MMM"
            placeholder="Filter by year & month"
            ref="datePicker"
            :open="openDatePicker"
            class="mb-3"
          >
            <template slot="renderExtraFooter">
              <a-button class="float-right my-2" @click="handleFilterMonth"
                >Filter</a-button
              >
            </template>
          </a-date-picker>
          <a-table
            :columns="columnsPharmacy"
            :dataSource="filteredData"
            :class="$style.table"
            :loading="isLoading"
            bordered
            @expand="handleExpand"
            :expandedRowKeys="expandedRows"
          >
            <template slot="no" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>

            <a-table
              :columns="innerColumns"
              :dataSource="innerData"
              :loading="isLoading"
              :pagination="false"
              slot="expandedRowRender"
            >
              <template slot="patient" slot-scope="text, record">
                <div>
                  {{ record.patient.code ? record.patient.code : '-' }}
                </div>
              </template>
              <template slot="programType" slot-scope="text, record">
                {{ record.programType.name }}
              </template>
            </a-table>
          </a-table>
          <!-- <a-table
            :columns="columnsTesting"
            :data-source="userDataArray"
            bordered
          >
            <template slot-scope="{ text }" slot="month">
              {{ text }}
            </template>
          </a-table> -->
        </div>
      </div>
      <div class="row">
        <div ref="document" class="col-xl-12 col-lg-12">
          <h5 class="mb-4"><strong>Patient Status</strong></h5>
          <div class="mb-5">
            <vue-chartist
              class="height-300"
              type="Bar"
              :data="monthlyPatientData"
              :options="monthlyPatientOptions"
              v-if="!isEmpty1"
            />
            <a-empty v-if="isEmpty1">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
            <span
              style="
                display: inline-block;
                background: #41b883;
                width: 15px;
                height: 15px;
                margin-right: 15px;
              "
            >
            </span>
            <span> Pasien Perpanjang </span>
            <span
              style="
                display: inline-block;
                background: #4b7cf3;
                width: 15px;
                height: 15px;
                margin-right: 15px;
                margin-left: 25px;
              "
            >
            </span>
            <span> Pasien Baru </span>
            <span
              style="
                display: inline-block;
                background: #ff0;
                width: 15px;
                height: 15px;
                margin-right: 15px;
                margin-left: 25px;
              "
            >
            </span>
            <span> Pasien Berhenti </span>
          </div>
        </div>
        <!-- Patients by city and program still disabled due to inacurate data -->
        <div ref="document" class="col-xl-6 col-lg-12">
          <h5 class="mb-4">
            <strong>Patients by City</strong>
          </h5>
          <!-- <a-month-picker placeholder="Select month" :default-value="moment()" @change="changeCityPatientMonth" /> -->
          <div class="mb-5" style="height: 100%">
            <vue-chartist
              style="height: 500px"
              type="Bar"
              :data="cityPatientData"
              :options="cityOptions"
              v-if="!isEmpty3"
            />
            <a-empty v-if="isEmpty3">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12">
          <h5 class="mb-4">
            <strong>Patients by Program</strong>
          </h5>
          <!-- <a-month-picker
            placeholder="Select month"
            :default-value="moment()"
            @change="changePatientProgramMonth"
          /> -->
          <div class="mb-5 mt-3">
            <PieChartPrograms
              :tagrisso="tagrissoCount"
              :faslodex="faslodexCount"
              :lynparza="lynparzaCount"
              :imfinzi="imfinziCount"
              :calquence="calquenceCount"
              v-if="user.role !== 'apl'"
            />
            <PieChartProgramsApl
              :tezpire="tezpireCount"
              :fasenra="fasenraCount"
              v-else
            />
            <a-empty v-if="isEmpty2">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-xl-6 col-lg-12">
        <h5 class="mb-4">
          <strong>Kota Pasien Bulan Ini</strong>
        </h5>
        <div class="mb-5">
          <vue-chartist
            class="height-300"
            type="Bar"
            :data="cityPatientData"
            :options="cityOptions"
            v-if="!isEmpty3"
          />
          <a-empty v-if="isEmpty3">
            <span slot="description"> Tidak Ada Data </span>
          </a-empty>
        </div>
      </div> -->
        <div class="col-xl-6 col-lg-12">
          <h5 class="mb-4">
            <strong>Kota Dokter Bulan Ini</strong>
          </h5>
          <div class="mb-5">
            <vue-chartist
              class="height-300"
              type="Bar"
              :data="cityDoctorData"
              :options="cityOptions"
              v-if="!isEmpty4"
            />
            <a-empty v-if="isEmpty4">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-12">
          <h5 class="mb-4">
            <strong>Alasan Berhenti Bulan Ini</strong>
          </h5>
          <div class="mb-5">
            <vue-chartist
              class="height-300"
              type="Pie"
              :data="terminateReasonThisMonth"
              :options="labelsPieOptions"
              :responsive-options="labelsPieResponsiveOptions"
              v-if="!isEmpty5"
            />
            <a-empty v-if="isEmpty5">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12">
          <h5 class="mb-4">
            <strong>Alasan Berhenti (Total)</strong>
          </h5>
          <div class="mb-5">
            <vue-chartist
              class="height-300"
              type="Pie"
              :data="terminateReasonAll"
              :options="labelsPieOptions"
              :responsive-options="labelsPieResponsiveOptions"
              v-if="!isEmpty6"
            />
            <a-empty v-if="isEmpty6">
              <span slot="description"> Tidak Ada Data </span>
            </a-empty>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 mb-5">
          <h5 class="mb-4">
            <strong>Average DoT, DoE, & DoU per month</strong>
          </h5>
          <div>
            <vue-chartist
              class="height-300"
              type="Line"
              :data="totalDotMonthly"
              :options="totalDotMonthlyOptions"
            />
          </div>
          <span
            style="
              display: inline-block;
              background: #41b883;
              width: 15px;
              height: 15px;
              margin-right: 15px;
            "
          >
          </span>
          <span> Duration of Enrollment </span>
          <span
            style="
              display: inline-block;
              background: #4b7cf3;
              width: 15px;
              height: 15px;
              margin-right: 15px;
              margin-left: 25px;
            "
          >
          </span>
          <span> Duration of Treatment </span>
          <span
            style="
              display: inline-block;
              background: #ff0;
              width: 15px;
              height: 15px;
              margin-right: 15px;
              margin-left: 25px;
            "
          >
          </span>
          <span> Duration of Uncompliance </span>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <h5 class="mb-4">
            <strong>Rate of Treatment & Rate of Uncompliance</strong>
          </h5>
          <div>
            <vue-chartist
              class="height-300"
              type="Line"
              :data="totalRouMonthly"
              :options="totalDotMonthlyOptions"
            />
          </div>
          <span
            style="
              display: inline-block;
              background: #41b883;
              width: 15px;
              height: 15px;
              margin-right: 15px;
            "
          >
          </span>
          <span> Rate of Treatment (DoT / DoE) </span>
          <span
            style="
              display: inline-block;
              background: #4b7cf3;
              width: 15px;
              height: 15px;
              margin-right: 15px;
              margin-left: 25px;
            "
          >
          </span>
          <span> Rate of Uncompliance (DoU / DoE)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import VueChartist from 'v-chartist'
import domtoimage from 'dom-to-image'
import html2canvas from 'html2canvas'
import ChartistTooltip from 'chartist-plugin-tooltips-updated'
import ChartistPointlabels from 'chartist-plugin-pointlabels'
// import ChartistPluginLegend from 'chartist-plugin-legend'
import moment from 'moment'
import VueHtml2pdf from 'vue-html2pdf'
import html2pdf from 'html2pdf.js'
import PieChartLegends from '@/components/pie-charts'
import PieChartPrograms from '@/components/pie-charts-patients-program'
import PieChartProgramsApl from '@/components/pie-charts-patients-program/apl.vue'
import {
  getAll,
  reportProgramStatus,
  reportPatientByCity,
  reportDoctorByCity,
  reportTerminateReason,
  reportArticleTotalViews,
  reportPatientByProgram,
} from '@/services/axios/api/dashboard'
import { getAllPatientData } from '@/services/axios/api/pasien'
import { testing } from '@/services/axios/api/testing'
import { getById as getProgramById } from '@/services/axios/api/program'
import { mapState } from 'vuex'
const terminatedCol = [
  {
    title: 'Pasien',
    dataIndex: 'code',
    className: 'bg-transparent border-left text-gray-6 width-50',
    scopedSlots: { customRender: 'code' },
    fixed: 'left',
    sorter: (a, b) => {
      return a.code.localeCompare(b.code)
    },
    filters: [],
    onFilter: (value, record) => {
      return record.city === value
    },
  },
  {
    title: 'Tanggal Bergabung',
    dataIndex: 'program.enrollDate',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'enrollDate' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.enrollDate) {
        return -1
      } else if (!b.program.enrollDate) {
        return 1
      } else {
        return a.program.enrollDate.localeCompare(b.program.enrollDate)
      }
    },
  },
  {
    title: 'Tanggal Berhenti',
    dataIndex: 'program.terminatedDate',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'terminatedDate' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.terminatedDate) {
        return -1
      } else if (!b.program.terminatedDate) {
        return 1
      } else {
        return a.program.terminatedDate.localeCompare(b.program.terminatedDate)
      }
    },
  },
  {
    title: 'Dokter',
    dataIndex: 'doctor',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'doctor' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else {
        return a.doctor.fullname.localeCompare(b.doctor.fullname)
      }
    },
    filters: [],
    onFilter: (value, record) => {
      return record.doctor ? record.doctor.fullname === value : -1
    },
  },
  {
    title: 'Farmasi',
    dataIndex: 'program.pharmacy',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'pharmacy' },
    sorter: (a, b) => {
      if (!a.program) {
        return -1
      } else if (!b.program) {
        return 1
      } else if (!a.program.pharmacy) {
        return -1
      } else if (!b.program.pharmacy) {
        return 1
      } else {
        return a.program.pharmacy.name.localeCompare(b.program.pharmacy.name)
      }
    },
    filters: [],
    onFilter: (value, record) => {
      return record.pharmacy ? record.pharmacy.name === value : -1
    },
  },
  {
    title: 'Status',
    dataIndex: 'program.isTerminated',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'isTerminated' },
    // filters: [
    //   {
    //     text: 'Belum Terdaftar',
    //     value: 'Belum Terdaftar',
    //   },
    //   {
    //     text: 'Pasien Baru',
    //     value: 'Pasien Baru',
    //   },
    //   {
    //     text: 'Berhenti',
    //     value: 'Berhenti',
    //   },
    //   {
    //     text: 'Perpanjang',
    //     value: 'Perpanjang',
    //   },
    // ],
    onFilter: (value, record) => {
      if (value === 'Belum Terdaftar') return record.program === null
      else if (value === 'Pasien Baru')
        return (
          record.program &&
          record.program.checkPoint !== 6 &&
          record.prevProgram === null &&
          record.isTerminated === null
        )
      else if (value === 'Perpanjang')
        return record.prevProgram && record.isTerminated !== true
      else if (value === 'Berhenti') return record.isTerminated
      else return record.program === value
    },
  },
  {
    title: 'Alasan Berhenti',
    dataIndex: 'terminatedMessage',
    className: 'bg-transparent',
    scopedSlots: { customRender: 'terminatedMessage' },
    filters: [],
    onFilter: (value, record) => {
      return record.terminatedMessage ? record.terminatedMessage === value : 0
    },
  },
]
const innerColumns = [
  {
    title: 'Patient',
    dataIndex: 'patient',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'patient' },
    key: `patient`,
    // filters: [],
  },
  {
    title: 'Program Type',
    dataIndex: 'programType',
    className: 'bg-transparent text-gray-6',
    scopedSlots: { customRender: 'programType' },
    key: `programType`,
  },
  // {
  //   title: 'Total',
  //   dataIndex: 'count',
  //   className: 'bg-transparent text-gray-6',
  //   scopedSlots: { customRender: 'count' },
  //   key: `count`,
  //   sorter: (a, b) => {
  //     return a.count - b.count
  //   },
  //   // filters: [],
  // },
]

export default {
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  components: {
    'vue-chartist': VueChartist,
    VueHtml2pdf,
    PieChartLegends,
    PieChartPrograms,
    PieChartProgramsApl,
  },
  data() {
    return {
      cancelToken: '',
      terminatedCol,
      totalActive: 0,
      totalCarryOver: 0,
      totalTerminated: 0,
      // totalPatient:0,
      activePatientsCount: 0,
      registeredPatientsCount: 0,
      registeredUsersCount: 0,
      extendingPatientsCount: 0,
      verifiedPatientsCount: 0,
      registeredUserEmailVerifiedCount: 0,
      registeredUserCompletedProfileCount: 0,
      pendingExtendingPatient: 0,
      totalNewPatients: 0,
      migratedPatientCount: 0,
      maleCount: 0,
      femaleCount: 0,
      tagrissoCount: 0,
      faslodexCount: 0,
      lynparzaCount: 0,
      imfinziCount: 0,
      calquenceCount: 0,
      fasenraCount: 0,
      tezpireCount: 0,
      columnsPharmacy: [
        {
          title: 'No',
          dataIndex: 'no',
          className: 'bg-transparent text-gray-6',
          scopedSlots: { customRender: 'no' },
          width: 75,
          key: `no`,
          // filters: [],
        },
        {
          title: 'Nama Apotek',
          dataIndex: 'label',
          className: 'bg-transparent text-gray-6',
          scopedSlots: { customRender: 'label' },
          key: `label`,
          sorter: (a, b) => {
            return a.label.localeCompare(b.label)
          },
          // filters: [],
        },
        {
          title: 'Kota',
          dataIndex: 'city',
          className: 'bg-transparent text-gray-6',
          scopedSlots: { customRender: 'city' },
          key: `city`,
          sorter: (a, b) => {
            return a.city.localeCompare(b.city)
          },
        },
        {
          title: 'Total',
          dataIndex: 'count',
          className: 'bg-transparent text-gray-6',
          scopedSlots: { customRender: 'count' },
          key: `count`,
          sorter: (a, b) => {
            return a.count - b.count
          },
          // filters: [],
        },
      ],
      expandedRows: [],
      filteredData: [],
      innerData: [],
      isLoading: false,
      date: '',
      value: moment(),
      columnsTesting: [
        {
          title: 'JAN',
          children: [
            {
              title: 'Nama Apotek',
              dataIndex: 'label',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'label' },
              sorter: (a, b) => {
                return a.label.localeCompare(b.label)
              },
            },
            {
              title: 'Kota',
              dataIndex: 'city',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'city' },
              sorter: (a, b) => {
                return a.city.localeCompare(b.city)
              },
            },
            {
              title: 'Total',
              dataIndex: 'count',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'count' },
              sorter: (a, b) => {
                return a.count - b.count
              },
            },
          ],
        },
        {
          title: 'FEB',
          children: [
            {
              title: 'Nama Apotek',
              dataIndex: 'label',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'label' },
              sorter: (a, b) => {
                return a.label.localeCompare(b.label)
              },
            },
            {
              title: 'Kota',
              dataIndex: 'city',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'city' },
              sorter: (a, b) => {
                return a.city.localeCompare(b.city)
              },
            },
            {
              title: 'Total',
              dataIndex: 'count',
              className: 'bg-transparent text-gray-6',
              scopedSlots: { customRender: 'count' },
              sorter: (a, b) => {
                return a.count - b.count
              },
            },
          ],
        },
        // Add more columns for other months as needed
      ],
      userData: {
        JAN: [
          { label: 'Apotek A', city: 'Jakarta', count: 10 },
          { label: 'Apotek B', city: 'Surabaya', count: 15 },
          // Add more user data for January
        ],
        FEB: [
          { label: 'Apotek A', city: 'Jakarta', count: 10 },
          { label: 'Apotek B', city: 'Surabaya', count: 15 },
          // Add more user data for January
        ],
        // Add data for other months following the same structure
      },
      userDataArray: [],
      openDatePicker: false,
      innerColumns,
      totalCarryOverData: {
        series: [],
        label: [],
      },
      totalNewPatientsData: {
        series: [],
        label: [],
      },
      totalDotMonthly: {
        series: [],
        label: [],
      },
      totalRouMonthly: {
        series: [],
        label: [],
      },
      totalTerminatedData: {
        series: [],
        label: [],
      },
      dailyArticleViewsData: {
        series: [],
        label: [],
      },
      terminatedData: [],
      html2pdfoption: {
        html2canvas: {
          onclone: (element) => {
            const svgElements = Array.from(element.querySelectorAll('svg'))
            svgElements.forEach((s) => {
              const bBox = s.getBBox()
              s.setAttribute('x', bBox.x)
              s.setAttribute('y', bBox.y)
              s.setAttribute('width', bBox.width)
              s.setAttribute('height', bBox.height)
            })
          },
        },
      },
      loading: true,
      isTableLoading: true,
      json_data: [],
      terminated_data: [],
      active_data: [],
      isAdmin: false,
      json_fields: {
        No: 'no',
        'Nama Pasien': 'fullname',
        'Kode Pasien': 'code',
        Kota: 'city',
        'Tanggal Gabung': 'enrollDate',
        'Tanggal Berhenti': 'terminatedDate',
        Dokter: 'doctor',
        Farmasi: 'pharmacy',
        Status: 'programstatus',
        'Alasan Berhenti': 'terminatedMessage',
        // "Telephone 2": {
        //   field: "phone.landline",
        //   callback: (value) => {
        //     return `Landline Phone - ${value}`;
        //   },
        // },
      },
      isEmpty1: false,
      isEmpty2: false,
      isEmpty3: false,
      isEmpty4: false,
      isEmpty5: false,
      isEmpty6: false,
      totalPatient: 0,
      totalDoctor: 0,
      totalPharmacy: 0,
      totalLaboratorium: 0,
      totalNews: 0,
      chartOptions: {
        axisX: {
          showLabel: false,
          showGrid: false,
          offset: 0,
        },
        axisY: {
          showLabel: false,
          showGrid: false,
          offset: 0,
        },
        showArea: true,
        high: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
        chartPadding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
        fullWidth: true,
        height: '110px',
        showPoint: true,
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      chartData1: {
        series: [[]],
      },
      chartData2: {
        series: [[]],
      },
      chartData3: {
        series: [[]],
      },
      chartData4: {
        series: [[]],
      },
      monthlyPatientData: {
        labels: [],
        series: [],
      },
      totalDotMonthlyOptions: {
        seriesBarDistance: 10,
        reverseData: false,
        horizontalBars: false,
        axisY: {
          offset: 70,
          showGrid: true,
        },
        axisX: {
          showGrid: true,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: true,
          }),
          ChartistPointlabels({
            textAnchor: 'middle',
            labelInterpolationFnc: (value) => {
              return !value ? 0 : value
            },
          }),
        ],
      },
      monthlyPatientOptions: {
        seriesBarDistance: 25,
        reverseData: false,
        horizontalBars: false,
        // stackBars: true,
        // stackMode: 'overlap',
        axisY: {
          offset: 70,
          showGrid: true,
        },
        axisX: {
          showGrid: true,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: true,
          }),
          ChartistPointlabels({
            textAnchor: 'middle',
            labelInterpolationFnc: (value) => {
              return !value ? 0 : value
            },
          }),
        ],
      },
      cityPatientData: {
        labels: [],
        series: [],
      },
      cityDoctorData: {
        labels: [],
        series: [],
      },
      cityOptions: {
        seriesBarDistance: 1,
        height: '100%',
        reverseData: false,
        horizontalBars: true,
        axisY: {
          offset: 60,
          showGrid: false,
        },
        axisX: {
          showGrid: true,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      totalPatientData: {
        labels: [],
        series: [],
        axisY: {
          offset: 70,
          showGrid: false,
        },
        axisX: {
          showGrid: false,
        },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      labelsPieOptions: {
        // labelInterpolationFnc(value) {
        //   return value[0]
        // },
        plugins: [
          ChartistTooltip({
            anchorToPoint: false,
            appendToBody: true,
            seriesName: false,
          }),
        ],
      },
      labelsPieResponsiveOptions: [
        [
          'screen and (min-width: 640px)',
          {
            chartPadding: 30,
            labelOffset: 100,
            labelDirection: 'explode',
            labelInterpolationFnc(value) {
              return value
            },
          },
        ],
        [
          'screen and (min-width: 1024px)',
          {
            labelOffset: 80,
            chartPadding: 20,
          },
        ],
      ],
      terminateReasonThisMonth: {
        labels: [],
        series: [],
      },
      terminateReasonAll: {
        labels: [],
        series: [],
      },
    }
  },
  created() {
    this.getDashboardCardData()
    this.reportProgramStatusData()
    this.reportPatientByCityData()
    this.reportDoctorByCityData()
    this.reportTerminateReasonData()
    this.reportTerminateReasonAllData()
    // this.getPatientsData()
    this.getRole()
    this.reportArticleTotalViews()
    this.getPatientByProgram()
    // this.testingAPI()
  },
  mounted() {
    console.log(Object.values(this.userData).flat(), '<<<<HALOOO')
    this.userDataArray = Object.values(this.userData).flat()
  },
  methods: {
    moment,
    ConvertSvgGraph(doc) {
      // const self = this
      const element = document.getElementById('printable-element')
      // if (!element) {
      //   self.index++
      //   return
      // }
      domtoimage
        .toPng(element)
        .then(function (dataUrl) {
          var img = new Image()
          img.src = dataUrl
          document.body.appendChild(img)
        })
        .catch(function (error) {
          console.error('oops, something went wrong!', error)
        })
    },
    captureElement() {
      html2canvas(this.$refs.document, {
        onclone: (element) => {
          const svgElements = Array.from(element.querySelectorAll('svg'))
          svgElements.forEach((svgElement) => {
            svgElement.setAttribute('width', svgElement.scrollWidth)
            svgElement.setAttribute('height', svgElement.scrollHeight)
          })
          // console.log(svgElements, 'svgelemtn')
        },
      }).then(function (canvas) {
        document.body.appendChild(canvas)
      })
    },
    countPercentage(a, b) {
      if (b <= 0) {
        return 0
      }
      return Number((a * 100) / b).toFixed(2)
    },
    exportToPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: 'document.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' },
      })
    },
    getRole() {
      const role = window.localStorage.getItem('role')
      if (role === 'admin') {
        this.isAdmin = true
      }
      this.loading = false
    },
    async getPatientsData() {
      let res = await getAllPatientData()
      // console.log(res, 'getpatientsdata')
      const items = []
      const activeItems = []
      const teminatedItems = []
      const cityFilters = []
      this.terminatedData = []
      const filtersComparison = []
      res = res.filter((el) => el.code !== null)
      res.sort((a, b) => a.code.localeCompare(b.code))
      // console.log(res, 'racee')
      for (const i in res) {
        const user = res[i]
        let isApproved = false
        if (user.city) {
          const comparison = user.city.toUpperCase()
          if (!filtersComparison.includes(comparison)) {
            cityFilters.push(user.city)
            filtersComparison.push(comparison)
          }
        }
        if (user.program) {
          user.isTerminated = null
          user.prevProgram = null
          user.terminatedMessage = null
          user.doctor = null
          user.enrollDate = null
          user.terminatedDate = null
          user.pharmacy = null
          user.programstatus = null
          if (!user.program.isApproved) {
            isApproved = false
          } else {
            isApproved = true
          }
          if (user.program.isTerminated)
            user.isTerminated = user.program.isTerminated
          if (user.program.doctor) user.doctor = user.program.doctor.fullname
          if (user.program.enrollDate)
            user.enrollDate = moment(user.program.enrollDate).format(
              'DD MMM YYYY',
            )
          if (user.program.pharmacy) user.pharmacy = user.program.pharmacy.name
          if (user.program.terminatedDate)
            user.terminatedDate = moment(user.program.terminatedDate).format(
              'DD MMM YYYY',
            )
          if (user.program.prevProgram)
            user.prevProgram = user.program.prevProgram
          if (user.program.terminatedMessage)
            user.terminatedMessage = user.program.terminatedMessage

          if (
            user.program &&
            user.program.checkPoint !== 6 &&
            moment(user.program.reminderDate).isBefore(
              moment().subtract(3, 'months'),
            )
          )
            user.programstatus = 'Tidak Aktif'
          else if (
            user.program &&
            user.program.checkPoint !== 6 &&
            user.prevProgram === null &&
            user.isTerminated === null
          )
            user.programstatus = 'Pasien Baru'
          else if (user.isTerminated) user.programstatus = 'Berhenti'
          else if (user.prevProgram) user.programstatus = 'Perpanjang'
        } else {
          isApproved = false
        }
        if (user.isTerminated) {
          this.terminatedData.push(user)
          teminatedItems.push(user)
        }
        if (
          user.program &&
          user.program.checkPoint !== 6 &&
          user.isTerminated === null &&
          user.status === 1
        ) {
          activeItems.push(user)
        }
        if (user.status === 1) {
          items.push(user)
        }
        user.isApproved = isApproved
        this.isTableLoading = false
      }
      this.totalPatient = res.filter((el) => el.isApproved === true).length
      cityFilters.forEach((el) => {
        terminatedCol[0].filters.push({
          text: el,
          value: el,
        })
      })
      this.terminatedCol = terminatedCol
      for (const i in items) {
        let program = []
        setTimeout(async () => {
          program = await getProgramById(items[i].program.id)
        }, 1000)
        if (items[i].programtype) {
          items[i].programtype = program.programType.name
        } else {
          items[i].programtype = ''
        }
      }
      // console.log(items, 'items')
      items.forEach((el, i) => {
        el.no = i + 1
      })
      teminatedItems.forEach((el, i) => {
        el.no = i + 1
      })
      activeItems.forEach((el, i) => {
        el.no = i + 1
      })
      this.json_data = items
      this.terminated_data = teminatedItems
      this.active_data = activeItems
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    async getDashboardCardData() {
      this.isLoading = true
      let dateFilter = null
      if (this.value) {
        dateFilter = this.value
      }
      // console.log(dateFilter, '<<<')
      const res = await getAll(this.cancelToken, dateFilter)
      console.log(res, 'getDashboardCardData')
      if (res) {
        this.totalPatient = res.patientTotal ? res.patientTotal : 0
        this.totalDoctor = res.totalDoctor ? res.totalDoctor : 0
        this.totalPharmacy = res.totalPharmacy ? res.totalPharmacy : 0
        this.totalLaboratorium = res.totalLaboratorium
          ? res.totalLaboratorium
          : 0
        this.totalNews = res.totalNews ? res.totalNews : 0
        this.totalActive = res.totalActivePatients ? res.totalActivePatients : 0

        this.totalTerminated = res.terminatedCount ? res.terminatedCount : 0
        this.totalNewPatients = res.totalNewPatients ? res.totalNewPatients : 0
        this.maleCount = res.patientsByMaleGenderCount
          ? res.patientsByMaleGenderCount
          : 0
        this.registeredUsersCount = res.registeredUsersCount
          ? res.registeredUsersCount
          : 0
        this.activePatientsCount = res.activePatientsCount
          ? res.activePatientsCount
          : 0
        this.extendingPatientsCount = res.extendingPatientCount
          ? res.extendingPatientCount
          : 0
        this.verifiedPatientsCount = res.verifiedPatientsCount
          ? res.verifiedPatientsCount
          : 0
        this.femaleCount = res.patientsByFemaleGenderCount
          ? res.patientsByFemaleGenderCount
          : 0
        this.registeredUserCompletedProfileCount =
          res.registeredUserCompletedProfileCount
            ? res.registeredUserCompletedProfileCount
            : 0
        this.registeredUserEmailVerifiedCount =
          res.registeredUserEmailVerifiedCount
            ? res.registeredUserEmailVerifiedCount
            : 0
        this.pendingExtendingPatient = res.pendingExtendingPatient
          ? res.pendingExtendingPatient
          : 0
        this.migratedPatientCount = res.migratedPatientCount
          ? res.migratedPatientCount
          : 0
        // const columnPharmacy = []
        // const dataPharmacy = []
        // for (const key in res.pharmacyNotScanned) {
        //   const dataObj = {
        //     title: key,
        //     dataIndex: key,
        //     children: [
        //       {
        //         title: 'Nama Apotek',
        //         dataIndex: `${key}Label`,
        //         className: 'bg-transparent text-gray-6',
        //         scopedSlots: { customRender: 'label' },
        //         key: `label${key}`,
        //         sorter: (a, b) => {
        //           return a[`${key}Label`].localeCompare(b[`${key}Label`])
        //         },
        //         // filters: [],
        //       },
        //       {
        //         title: 'Kota',
        //         dataIndex: `${key}City`,
        //         className: 'bg-transparent text-gray-6',
        //         scopedSlots: { customRender: 'city' },
        //         key: `city${key}`,
        //         sorter: (a, b) => {
        //           return a[`${key}City`].localeCompare(b[`${key}City`])
        //         },
        //       },
        //       {
        //         title: 'Total',
        //         dataIndex: `${key}Count`,
        //         className: 'bg-transparent text-gray-6',
        //         scopedSlots: { customRender: 'count' },
        //         key: `count${key}`,
        //         sorter: (a, b) => {
        //           return a[`${key}Count`] - b[`${key}Count`]
        //         },
        //         // filters: [],
        //       },
        //     ],
        //   }

        //   // dataPharmacy.push(phar)
        //   columnPharmacy.push(dataObj)
        // }
        this.filteredData = res.pharmacyNotScanned
        this.innerData = res.pharmacyNotScanned.children
        // this.userDataArray = Object.values(this.userData).flat()

        // this.filteredData = Object.values(res.pharmacyNotScanned).flat()
      }
      this.isLoading = false
    },
    async reportArticleTotalViews() {
      const start = moment().add(-11, 'days').format('YYYY-MM-DD')
      const res = await reportArticleTotalViews(start, this.cancelToken)
      if (res && res.length) {
        const label = []
        const views = []
        for (const i in res) {
          label.push(res[i].label)
          views.push(res[i].articleViewsCount)
        }
        const totalArticleViews = {
          name: 'Total Article Views',
          data: views,
        }

        this.dailyArticleViewsData.series.push(totalArticleViews)
        this.dailyArticleViewsData.labels = label
      }
      // console.log(start, this.dailyArticleViewsData)
    },
    async reportProgramStatusData() {
      const start = moment().format('YYYY-MM-DD')
      const res = await reportProgramStatus(start, this.cancelToken)
      // console.log(res, 'reportProgramStatusData')
      if (res && res.length) {
        const enroll = []
        const terminate = []
        const carryover = []
        const label = []
        const active = []
        const patients = []
        const doctors = []
        const pharmacies = []
        const laboratories = []
        const dot = []
        const doe = []
        const dou = []
        const rot = []
        const rou = []

        const targetPatients = []

        let isEmpty = true
        res.forEach((item) => {
          patients.push(item.patients)
          doctors.push(item.doctors)
          pharmacies.push(item.pharmacies)
          laboratories.push(item.laboratories)
          if (
            item.enroll ||
            item.terminate ||
            item.carryover ||
            item.active ||
            item.targetPatients[0]
          ) {
            if (item.targetPatients[0])
              targetPatients.push(item.targetPatients[0].total)
            else targetPatients.push(0)
            enroll.push(item.enroll)
            terminate.push(item.terminate)
            dot.push(item.dotAvg.toFixed(2))
            doe.push(item.doeAvg.toFixed(2))
            dou.push(item.douAvg.toFixed(2))
            rou.push(Math.round((item.dou / item.doe) * 100) / 100)
            rot.push(Math.round((item.dot / item.doe) * 100) / 100)
            carryover.push(item.carryover)
            label.push(item.label)
            active.push(item.active)
            // this.totalActive += item.active
            // this.totalCarryOver += item.carryover
            isEmpty = false
          }
        })
        // console.log(carryover, 'carryover')
        // console.log(totalActive, 'active')
        this.isEmpty1 = isEmpty
        this.isEmpty2 = isEmpty

        this.monthlyPatientData.labels = label
        const enrollData = {
          name: 'Pasien Baru',
          data: enroll,
        }
        const terminateData = {
          name: 'Pasien Berhenti',
          data: terminate,
        }
        const carryoverData = {
          name: 'Pasien Perpanjang',
          data: carryover,
        }
        // const targetPatientData = {
        //   name: 'Target Pasien',
        //   data: targetPatients,
        // }

        this.monthlyPatientData.series.push(enrollData)
        this.monthlyPatientData.series.push(carryoverData)
        this.monthlyPatientData.series.push(terminateData)
        // this.monthlyPatientData.series.push(targetPatientData)

        patients.forEach((x) => {
          this.chartData1.series[0].push(x)
        })

        doctors.forEach((x) => {
          this.chartData2.series[0].push(x)
        })

        pharmacies.forEach((x) => {
          this.chartData3.series[0].push(x)
        })

        laboratories.forEach((x) => {
          this.chartData4.series[0].push(x)
        })

        this.totalPatientData.labels = label
        this.totalPatientData.series.push(active)

        this.totalCarryOverData.labels = label
        this.totalCarryOverData.series.push(carryover)

        this.totalNewPatientsData.labels = label
        this.totalNewPatientsData.series.push(enroll)

        this.totalDotMonthly.labels = label
        this.totalDotMonthly.series.push(dot)
        this.totalDotMonthly.series.push(doe)
        this.totalDotMonthly.series.push(dou)
        // console.log(dot, '<<<DOT')
        // console.log(doe, '<<<DOE')
        // console.log(dou, '<<<DOU')
        this.totalRouMonthly.labels = label
        this.totalRouMonthly.series.push(rou)
        this.totalRouMonthly.series.push(rot)
        // console.log(rou, '<<<ROU')
        // console.log(rot, '<<<ROT')

        this.totalTerminatedData.labels = label
        this.totalTerminatedData.series.push(terminate)
      } else {
        this.isEmpty1 = true
        this.isEmpty2 = true
        console.log('MASUK SINI')
      }
    },
    changeCityPatientMonth(date, dateString) {
      this.cityPatientData.series = []
      this.reportPatientByCityData(dateString)
    },
    changePatientProgramMonth(date, dateString) {
      // console.log(dateString)
      this.getPatientByProgram(dateString)
    },
    async getPatientByProgram(dateStr) {
      let date = moment().format('YYYY-MM-DD')
      if (dateStr) date = moment(dateStr + '-01').format('YYYY-MM-DD')
      if (this.user.role !== 'apl') {
        const tagrisso = await reportPatientByProgram(
          '3a1845a1-28df-403d-a40d-e8173f511fc9',
          date,
        )
        const faslodex = await reportPatientByProgram(
          'f20ef325-c767-444c-927d-71d4c3600f67',
          date,
        )
        const lynparza = await reportPatientByProgram(
          '579d64ca-8ba8-458b-9534-47207e86a6a6',
          date,
        )
        const imfinzi = await reportPatientByProgram(
          'a128e0fa-de64-4ea1-be41-d0dd0105454f',
          date,
        )
        const calquence = await reportPatientByProgram(
          '899d559b-5ce5-4fff-b5bb-4bbf55de5c63',
          date,
        )
        this.tagrissoCount = tagrisso.patientByProgram
        this.faslodexCount = faslodex.patientByProgram
        this.lynparzaCount = lynparza.patientByProgram
        this.imfinziCount = imfinzi.patientByProgram
        this.calquenceCount = calquence.patientByProgram
      } else {
        const fasenra = await reportPatientByProgram(
          '6f1a1b69-c6bb-44cc-8aa8-e23c9919ac63',
          date,
        )
        const tezpire = await reportPatientByProgram(
          '0c6f98df-30dd-4713-bac3-4055b39f9978',
          date,
        )
        this.fasenraCount = fasenra.patientByProgram
        this.tezpireCount = tezpire.patientByProgram
      }
    },
    async reportPatientByCityData(date) {
      let start = moment().format('YYYY-MM-DD')
      if (date) start = moment(date + '-01').format('YYYY-MM-DD')
      const res = await reportPatientByCity(start, this.cancelToken)
      // console.log(res, 'reportPatientByCityData')
      if (res && res.length) {
        const data = []
        const label = []

        let isEmpty = true
        res.forEach((item) => {
          if (item.count) {
            label.push(item.label)
            data.push(item.count)
            isEmpty = false
          }
        })
        this.isEmpty3 = isEmpty

        this.cityPatientData.labels = label
        this.cityPatientData.series.push(data)
      } else {
        this.isEmpty3 = true
      }
    },
    async reportDoctorByCityData() {
      const start = moment().format('YYYY-MM-DD')
      const res = await reportDoctorByCity(start, this.cancelToken)
      // console.log(res, 'reportDoctorByCityData')
      if (res && res.length) {
        const data = []
        const label = []

        let isEmpty = true
        res.forEach((item) => {
          if (item.count) {
            label.push(item.label)
            data.push(item.count)
            isEmpty = false
          }
        })
        this.isEmpty4 = isEmpty

        this.cityDoctorData.labels = label
        this.cityDoctorData.series.push(data)
      } else {
        this.isEmpty4 = true
      }
    },
    async reportTerminateReasonData() {
      const start = moment().format('YYYY-MM-DD')
      const res = await reportTerminateReason(start, '', this.cancelToken)
      // console.log(res, 'reportTerminateReasonData')
      if (res && res.length) {
        const data = []
        const label = []

        let isEmpty = true
        res.forEach((item) => {
          if (item.count) {
            label.push(item.label)
            data.push(item.count)
            isEmpty = false
          }
        })
        this.isEmpty5 = isEmpty

        this.terminateReasonThisMonth.labels = label
        this.terminateReasonThisMonth.series = data
      } else {
        this.isEmpty5 = true
      }
    },
    async reportTerminateReasonAllData() {
      const start = moment().format('YYYY-MM-DD')
      const res = await reportTerminateReason(start, 'all')
      console.log(res, 'reportTerminateReasonAllData')
      if (res && res.length) {
        const data = []
        const label = []

        let isEmpty = true
        res.forEach((item) => {
          if (item.count) {
            label.push(item.label)
            data.push(item.count)
            isEmpty = false
          }
        })
        this.isEmpty6 = isEmpty

        this.terminateReasonAll.labels = label
        this.terminateReasonAll.series = data
      } else {
        this.isEmpty6 = true
      }
    },
    onDateValueChange(val) {
      this.date = val
      this.value = val
      // this.getAllNews()
    },
    handleResetDate() {
      this.date = null
      this.value = null
      // this.getAllNews()
    },
    handlePanelChange2(value) {
      this.date = value
      this.value = moment(value._d)
    },
    handleFilterMonth() {
      this.openDatePicker = false
      this.getDashboardCardData()
    },
    handleOpenChange(status) {
      this.openDatePicker = status
      this.value = moment()
    },
    handleExpand(expanded, record) {
      // Add record to expandedRows if not already expanded
      console.log(expanded, '<<<<EXPAND')
      console.log(record, '<<<<RECORD')
      const keys = []
      if (expanded) {
        keys.push(record.key) // Add the key of the row to be expanded
      }
      this.expandedRows = keys
      // if (!this.expandedRows.includes(record.key)) {
      //   this.expandedRows.push(record.key)
      // }
      this.innerData = record.childrenData
    },
    handleExpandedRowsChange(row) {
      this.expandedRows = row
      console.log(this.expandedRows, 'BEFORE')
      const currentRow = [...this.expandedRows].pop()
      // console.log(row, '<<<<<<ROW')
      // console.log(currentRow, '<<<<<<ROWCURRENT')
      this.expandedRows = new Array(currentRow)
      console.log(this.expandedRows, 'AFTER')
    },
    async testingAPI() {
      await testing()
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style lang="scss" module>
@import '../style.module.scss';
</style>
